import BlmMonitor from 'blm-monitor';
import { getEnv, isTest, isDevMode } from './env';
import { handleConfig, observerTTI, checkWhiteScreen } from './common';
import { isInnerYueyue, getAppVerson } from './appMonitor/appTools';
import { BridgeConnectReport, pageManagerReport, resManagerReport, errManagerReport } from './appMonitor';
import { MINSUPPORTAPPVERSION } from './const';

window.BlmMonitor = BlmMonitor;
let instance;

const taskQueueList = [];

export class H5Mointor {
  initReady = false;
  addPoint = BlmMonitor.addPoint.bind(BlmMonitor);
  addError = BlmMonitor.addError.bind(BlmMonitor);
  config;
  /**
   * @description: constructor
   * @param: config
   * obj.isInApp: boolean; 端内/外
   * obj.project: string; 区分项目
   * obj.projectVersion: string; 项目版本，自定义字符串
   * obj.category: 'dj'; 业务线 固定dj
   * obj.Vue: Vue; 用于监控vue错误
   * obj.appnm: string; 应用名，默认driver(非必传)
   * obj.channel: string; 渠道，默认h5，支持传参(非必传)
   * obj.domainObj: { 'dj-delivery-admin': 'pt-admin-daily2.dsupplatform.com' }; 配置自定义上报api host
   * obj.apiHostAuto: number; 设置api域名，设置数字0不会做域名合规逻辑(非必传)
   * obj.userInfo: 研发埋点初始化需要传递userInfo
   * obj.tenantId: string; 端外初始化monitor 需要手动传入租户id
   * obj.uid: string; 端外初始化monitor 需要手动传入uid
   */
  constructor(config) {
    const isInApp = config?.isInApp || isInnerYueyue();
    this.config = handleConfig({ ...config, isInApp });
    this.init();
  }
  // 初始化

  async init() {
    try {
      if (isDevMode()) return;
      BlmMonitor.start({
        devMode: isTest(), // 是否上报到线下环境，false: 线上环境，true：线下环境
        envVar: getEnv(), // dev/daily/daily2/pre/pre2/gray/publish
        ajax: {
          flag: true,
          duration: 15000
        },
        ignoreList: {
          js: ['Network Error', 'Script error.', 'activeEvent is not defined'] // 过滤的js错误
        },
        ...this.config
      });
      this.initReady = true;
      // 是否App环境，且app版本支持
      if (this.config.isInApp) {
        const { appVersion } = await getAppVerson();
        const project = this.config?.project;
        if (MINSUPPORTAPPVERSION && appVersion >= MINSUPPORTAPPVERSION) {
          BlmMonitor.config({
            page: {
              onSubmit: (page) => {
                pageManagerReport(page, project);
              }
            },
            resource: {
              onSubmit: (res) => {
                resManagerReport(res, project);
              }
            },
            error: errManagerReport
          });
          BridgeConnectReport(customErrorReport);
        }
      }
      // TTI上报
      observerTTI(this.addPoint.bind(BlmMonitor));
      // 白屏上报
      checkWhiteScreen(this.config.project);
      // 任务队列处理
      this.loopQueueTask();
    } catch (err) {
      console.log('blm-monitor初始化失败');
    }
  }

  loopQueueTask() {
    while (taskQueueList.length) {
      const task = taskQueueList.shift();
      try {
        if (typeof task === 'function') {
          task();
        }
      } catch (err) {
        console.log('任务执行失败：', err);
      }
    }
  }
  // 更新配置

  updateConfig(config) {
    BlmMonitor.config(config);
  }
}
/**
 * 自定义上报
 * @param errorInfo.name
 * @param errorInfo.msg
 * @param errorInfo.errorType 枚举 -> ErrorType
 * @param errorInfo.level 枚举 -> ErrorLevel
 */
export function customErrorReport(errorInfo) {
  const { name, msg, errorType, level } = errorInfo;
  BlmMonitor.addError({ name, msg }, { errorType, level });
}
// 初始化
export const getMonitorInstance = (config) => {
  try {
    return instance || (instance = new H5Mointor(config));
  } catch (e) {
    console.log('e', e.message);
  }
};
// 更新配置
export const updateMonitorConfig = (config) => {
  const queueItem = () => {
    BlmMonitor.config(config);
  };
  taskQueueList.push(queueItem);
  if (instance?.initReady) {
    instance.loopQueueTask();
  }
};
